import React, { useEffect, useState, Fragment } from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';
import Traductor from '../components/Traductor';
import ScrollToTop from '../components/ScrollToTop';
import LicenseText from '../components/footer/LicenceText';

/* Command to export the licenses to json file (https://www.npmjs.com/package/npm-license-crawler)
    npm-license-crawler --onlyDirectDependencies --json src/licenses.json
*/

const LicensesPage = () => {
    const t = new Traductor();

    const [mitList, setMitList] = useState([]);
    const [iscList, setIscList] = useState([]);
    const [bsdList, setBsdList] = useState([]);
    const [otherList, setOtherList] = useState([]);

    useEffect(() => {
        let MIT = [];
        let ISC = [];
        let BSD = [];
        let Others = [];

        let file = require('../licenses.json');
        if (file) {
            let dependencies = Object.entries(file);
            dependencies.forEach(function (element) {
                if (element && element.length > 1) {
                    switch (element[1].licenses) {
                        case 'MIT':
                            MIT.push(element);
                            break;
                        case 'ISC':
                            ISC.push(element);
                            break;
                        default:
                            if (element[1].licenses.indexOf('BSD') >= 0)
                                BSD.push(element);
                            else Others.push(element);
                            break;
                    }
                }
            });
            setMitList(MIT);
            setIscList(ISC);
            setBsdList(BSD);
            setOtherList(Others);
        }
    }, []);

    const createLicenseRows = licenseType => {
        let rows = [];

        switch (licenseType) {
            case 'MIT':
                if (mitList && mitList.length > 0) {
                    mitList.map((element, i) => {
                        if (element !== null && element !== undefined)
                            rows.push(splitNameVersion(element[0].split('@')));
                        return null;
                    });
                }
                break;

            case 'ISC':
                if (iscList && iscList.length > 0) {
                    iscList.map((element, i) => {
                        if (element !== null && element !== undefined)
                            rows.push(splitNameVersion(element[0].split('@')));
                        return null;
                    });
                }
                break;

            case 'BSD':
                if (bsdList && bsdList.length > 0) {
                    bsdList.map((element, i) => {
                        if (element !== null && element !== undefined)
                            rows.push(splitNameVersion(element[0].split('@')));
                        return null;
                    });
                }
                break;

            default:
                if (otherList && otherList.length > 0) {
                    otherList.map((element, i) => {
                        if (element !== null && element !== undefined)
                            rows.push(splitNameVersion(element[0].split('@')));
                        return null;
                    });
                }
                break;
        }
        return rows;
    };

    const splitNameVersion = splittedName => {
        if (splittedName && splittedName.length > 1 && splittedName[0] !== '') {
            return (
                <tr key={`${splittedName[0]}${splittedName[1]}`}>
                    <td> {splittedName[0]} </td>
                    <td> {splittedName[1]} </td>
                </tr>
            );
        }
    };

    const sectionLicense = (licenseName, licenseType) => {
        return (
            <section className="js-content-section o-content-section ">
                <div className="o-page-wrap  o-page-wrap--xxsmall">
                    <div className="o-component-wrapper">
                        <header className="u-text-center u-mb-large">
                            <h3>
                                <p>{licenseName}</p>
                            </h3>
                        </header>
                        <div className="c-table-wrapper">
                            <table
                                width="100%"
                                cellSpacing="0"
                                cellPadding="1"
                                border="0"
                            >
                                <tbody>
                                    <tr>
                                        <th className="c-table__cell--highlight">
                                            <b>Nombre</b>
                                        </th>
                                        <th className="c-table__cell--highlight">
                                            <b>Version</b>
                                        </th>
                                    </tr>
                                    {createLicenseRows(licenseType)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <LicenseText licenseType={licenseType} />
                </div>
            </section>
        );
    };

    return (
        <Fragment>
            <ScrollToTop></ScrollToTop>
            <div
                className="c-hero-teaser c-hero-teaser--no-image c-hero-teaser--auto"
                data-testid="licensesPageTestId"
            >
                <div className="c-hero-teaser__image"></div>
                <div
                    id="js-hero-teaser-content"
                    className="c-hero-teaser__content u-pt-small u-mt-none"
                >
                    <div className="c-hero-teaser__content-inner">
                        <header className="c-hero-teaser__heading">
                            <div className="c-hero-teaser__title">
                                <h1>
                                    <span className="c-hero-teaser__title-row">
                                        {t.getTraduction(
                                            'ThirdPartyLicenseNotice'
                                        )}
                                    </span>
                                    <br />
                                </h1>
                            </div>
                        </header>
                    </div>
                </div>
            </div>

            <main className="o-main">
                {mitList.length > 0
                    ? sectionLicense('Licencia-MIT', 'MIT')
                    : null}
                {iscList.length > 0
                    ? sectionLicense('Licencia-ISC', 'ISC')
                    : null}
                {bsdList.length > 0
                    ? sectionLicense('Licencia-BSD', 'BSD')
                    : null}
            </main>
        </Fragment>
    );
};
export default withCookies(withRouter(LicensesPage));
